import { Component, OnInit } from '@angular/core';
import { AppConstants } from '../../../../appConstants';
import { Faq } from '../../../../interfaces/faq.interface';
import { ResponseDataBase } from '../../../../interfaces/index.interface';
import { ResourceService } from '../../../../services/index.service';
import { PortalConfigurationService } from '../../../../services/portal-configuration/portal-configuration.service';
declare var $: any;

@Component({
  selector: 'faqs-page',
  templateUrl: './faqs.page.html'
})
export class FaqsPage implements OnInit {

  alert;
  selectedFaq: Faq;
  editedFaq: Faq;
  newFaq: Faq = {
    question: null,
    answer: null,
    language: 'es'
  };

  constructor(public _portalConfigurationService: PortalConfigurationService,
    public _resourceService: ResourceService) {
    this._portalConfigurationService.getFaqs();
  }

  addFaq() {
    delete this._resourceService.alert;
    this._portalConfigurationService.addFaq(this.newFaq).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        $('#AddFaqModal').modal('hide');
        window.scrollTo(0, 0);
        this._resourceService.alert = 'THE_FAQ_HAS_BEEN_CREATED';
        this._portalConfigurationService.getFaqs();
        delete this._resourceService.alert;
        this.newFaq = {
          question: null,
          answer: null,
          language: 'es'
        };
      } else {
        this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
        window.scrollTo(0, 0);
      }
      this._portalConfigurationService.loading = false;
    });
  }

  selectFaq(faq) {
    this.selectedFaq = faq;
  }

  editFaq(faq) {
    this.selectedFaq = faq;
    this.editedFaq = this._resourceService.cloneObject(faq);
  }

  cancelEditFaq() {
    delete this.selectedFaq;
  }

  deleteFaq() {
    let params = {
      id: this.selectedFaq.id
    }
    this._portalConfigurationService.deleteFaq(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.alert = 'THE_FAQ_HAS_BEEN_DELETED';
        this._portalConfigurationService.getFaqs();
      } else {
        this.alert = response.METADATA.ERROR_MESSAGE;
        this._portalConfigurationService.loading = false;
      }
    });
  }

  updateFaq() {
    this._portalConfigurationService.updateFaq(this.editedFaq).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.alert = 'FAQ_SUCCESSFULLY_CHANGE';
        $('#EditedFaqModal').modal('hide');
        this._portalConfigurationService.getFaqs();
      } else {
        this.alert = 'FAQ_COULD_NOT_BE_CHANGED';
        $('#EditedFaqModal').modal('hide');
      }
      this._portalConfigurationService.loading = false;
    });
  }

  ngOnInit(): void {
  }

}
